import { EMPTY_LIST } from '../../../constants/common'
import { getQaSelector } from '../../../utils/common'
import { QA_NAME_GRETA_AI_CHAT_EMPTY_STATE } from '../GretaAIChat.constants'
import { useGretaAIChatContext } from '../GretaAIChat.hooks'
import { getGretaAIChatEmptyStateSubtitleKey } from '../GretaAIChat.utils.sourceTexts'
import { GretaAIChatEmptyStateGreeting } from '../GretaAIChatEmptyStateGreeting'
import { GretaAIChatFinancePreview } from '../GretaAIChatFinancePreview'
import { GretaAIChatSourcePicker } from '../GretaAIChatSourcePicker'
import { GretaAIChatSuggestedPrompt } from '../GretaAIChatSuggestedPrompt'

import * as styles from './GretaAIChatEmptyState.module.css'

function GretaAIChatEmptyState({
  displayName,
  isLimitReached = false,
  suggestedPrompts = EMPTY_LIST,
  onSelectPrompt,
  onSendPrompt,
}) {
  const { source } = useGretaAIChatContext()

  const {
    canSwitch,
    isFinanceNew,
    isFinancePreview,
    isSourceChoiceEnabled,
    source: chatSource,
    onSelectSource,
  } = source

  const subtitleKey = getGretaAIChatEmptyStateSubtitleKey(isSourceChoiceEnabled)

  const qaProps = getQaSelector({ value: QA_NAME_GRETA_AI_CHAT_EMPTY_STATE })

  return (
    <div {...qaProps} className={styles.root}>
      <div className={styles.content}>
        <GretaAIChatEmptyStateGreeting
          displayName={displayName}
          subtitleKey={subtitleKey}
        />

        {isSourceChoiceEnabled ? (
          <GretaAIChatSourcePicker
            canSwitch={canSwitch}
            isFinanceNew={isFinanceNew}
            source={chatSource}
            onSelect={onSelectSource}
          />
        ) : null}

        {isFinancePreview ? (
          <GretaAIChatFinancePreview />
        ) : suggestedPrompts.length > 0 ? (
          <div className={styles.prompts}>
            {suggestedPrompts.map(prompt => (
              <GretaAIChatSuggestedPrompt
                disabled={isLimitReached}
                key={prompt.id}
                prompt={prompt}
                onSelectPrompt={onSelectPrompt}
                onSendPrompt={onSendPrompt}
              />
            ))}
          </div>
        ) : null}
      </div>
    </div>
  )
}

export default GretaAIChatEmptyState
